<template lang="pug">
  div
    template(
      v-if="!loading")
      v-card.mb-3(
        v-for="item in items"
        :key="item.id")
        .list-mobile
          .list-mobile__top
            .list-mobile__title {{ item ? item.name : '-' | shortstr }}
            .list-mobile__button
              v-btn(
                :disabled="isConsultant"
                icon
                @click="selected = item")
                v-icon(
                  font-size="1"
                  icon="cog")
          .list-mobile__content
            .list-mobile__item
              .list-mobile__item-label {{ 'base.rest_days' | translate }}
              .list-mobile__item-value {{ getRestOfDays(item) }}
            .list-mobile__item
              .list-mobile__item-label
                days-count-toggler(v-model="days")
              .list-mobile__item-value
                span(:class="{ skeleton: wait }") {{ wait ? '' : Math.floor(item.daily_feed_intake * days) }} 
            .list-mobile__item
              .list-mobile__item-label {{ 'base.stock_rest' | translate }} [{{ 'base.kg' | translate }}]
              .list-mobile__item-value {{ item.total_amount | floor }}
            .list-mobile__item
              .list-mobile__item-label {{ 'base.dry_metter' | translate }}
              .list-mobile__item-value(v-if="item.name !== 'H2O'")
                input.input-number(
                  type="number",
                  :min="1"
                  :max="100"
                  @blur="updateDryMatter(item)"
                  name="dry_matter",
                  id="dry_matter"
                  :disabled="!hasPermission('ingredient', 'change')"
                  v-model="item.dry_matter")
            .list-mobile__item
              .list-mobile__item-label {{ 'base.price' | translate }} [{{ 'base.currency' | translate }}]
              .list-mobile__item-value {{ item.total_price | floor }}

      v-table-body(
        v-if="loading"
        outside-table
        :empty="!ingredients.length")

    template(v-else)
      v-card.mb-3(v-for="i in 5" :key="i")
        .list-mobile.list-mobile--skeleton
          .list-mobile__top.mb-1
            .list-mobile__title-skeleton
          .list-mobile__content
            .list-mobile__item(v-for="j in 4" :key="`${i}-${j}`")
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1

    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")
    v-dialog(
      max-width="340"
      :value="!!selected"
      @input="selected = null")
      edit-modal(
        :data="selected"
        @update="handleUpdate"
        @close="selected = null")
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import EditModal from '../modals/EditModal'
import DaysCountToggler from './DaysCountToggler'
import paginationMixin from '@/mixins/pagination.mixin'
import UiNumberInput from '@/components/ui/ui-number-input/UiNumberInput.vue'
import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'

export default {
  name: 'IngredientsTableMobile',

  mixins: [paginationMixin],

  components: {
    DaysCountToggler,
    UiPagination,
    UiNumberInput,
    EditModal
  },

  data: () => ({
    days: 1,
    wait: true,
    selected: null,
  }),
  computed: {
    ...mapGetters('ingredients', [
      'getDailyFeedIntakesData'
    ]),
    dailyFeedIntakesData () {
      return this.getDailyFeedIntakesData
    },
  },
  mounted () {
    this.setupPagination(
      api.ingredients.list,
      {
        farm: this.$route.params.farm_id,
        is_animalfeed: false
      },
      `stockingredients_${this.$route.params.farm_id}`
    )
    this.loadDailyFeedIntakes()
  },

  methods: {
    handleUpdate () {
      this.setupPagination(
        api.ingredients.list,
        {
          farm: this.$route.params.farm_id,
          is_animalfeed: false
        },
        `stockingredients_${this.$route.params.farm_id}`
      )
      this.loadDailyFeedIntakes()
    },
    async updateDryMatter (ingredient) {
      await this.$nextTick()

      // Clamp dry matter between 0 and 100
      ingredient.dry_matter = Math.max(0, Math.min(100, ingredient.dry_matter))

      try {
        const { errors } = await api.ingredients.updateById(ingredient.id, ingredient)

        if (!errors) {
          this.$toasted.show(this.$t('info.changed'))
        }
      } catch (error) {
        this.$toasted.error(this.$t('errors.unexpected'))
      }
    },
    getRestOfDays (item) {
      if (item.daily_feed_intake > 0) {
        return Math.floor(item.total_amount / item.daily_feed_intake)
      }
      return '-'
    },
    async loadDailyFeedIntakes () {
      this.wait = true
      try {
        const { data } = await api.ingredients.dailyFeedIntakes({
          farm: this.$route.params.farm_id,
          is_animalfeed: false
        })
        this.items.forEach(item => {
          const updatedItem = data.find(d => d.id === item.id)
          if (updatedItem) {
            item.daily_feed_intake = updatedItem.daily_feed_intake
          }
        })
        this.wait = false
        this.$forceUpdate()
      } catch (error) {
        console.error('Error loading ingredients:', error)
        this.wait = false
      }
    },
  },
  watch: {
    dailyFeedIntakesData () {
      this.loadDailyFeedIntakes()
    }
  }
}
</script>
<style scoped>
span.skeleton {width: 20px;height: 16px; display: inline-block;}

.skeleton {
  animation: skeleton-loading 1s linear infinite alternate;
  border-radius: 3px;
}
.input-number {
    width: auto;
    min-width: 6rem;
    max-width: 9rem;
    padding: .5rem;
    text-align: right;
    background-color: #F4F4F4;
    font-weight: 700;
    border-bottom: 1px solid #D8D8D8;
}
.input-number:disabled {
  background: unset;
  border: unset;
  padding: 0;
  font-weight: normal;
}
@keyframes skeleton-loading {
  0% {
    background-color: rgba(238, 238, 238, 0.7); /* #eee with 70% opacity */
  }
  100% {
    background-color: rgba(238, 238, 238, 0.95); /* #eee with 95% opacity */
  }
}
</style>